import { isQAActive } from '../../filters/questions/isQAActive';
import { useEvent } from '../eventHooks';

export function useIsQAActive(eventId) {
    const event = useEvent(eventId);
    return event.joined && isQAActive(event);
}
